<script>
  import { modal } from '../lib/modal.js';
  import { createEventDispatcher } from 'svelte';
  import { companyInvoicesApi } from '../stores/api.js';
  import { t } from '../i18n/index.js';
  import ErrorBanner from './ErrorBanner.svelte';

  export let companyId;
  export let invoiceId;
  export let identificativoSdi = '';

  const dispatch = createEventDispatcher();

  let esito = 'EC01';
  let numeroFattura = '';
  let annoFattura = new Date().getFullYear();
  let posizioneFattura = 1;
  let descrizione = '';
  let sending = false;
  let result = null;
  let error = null;

  async function handleSend() {
    sending = true;
    error = null;
    result = null;
    try {
      // Company-scoped endpoint: the button that opens this modal is shown to
      // any user whose inbound invoice allows the esito_sent transition, and
      // the /api/admin twin refuses everyone without the global admin role.
      const res = await companyInvoicesApi.sendEsito(companyId, invoiceId, {
        esito,
        numeroFattura,
        annoFattura: parseInt(annoFattura, 10),
        posizioneFattura: parseInt(posizioneFattura, 10),
        descrizione: descrizione || undefined,
      });
      result = res;
      if (res.success) {
        setTimeout(() => dispatch('sent'), 1500);
      }
    } catch (err) {
      error = err;
    } finally {
      sending = false;
    }
  }
</script>

<!-- svelte-ignore a11y_click_events_have_key_events a11y_no_static_element_interactions -->
<div class="modal-backdrop" on:click|self={() => dispatch('close')}>
  <div class="modal-content w-full max-w-lg p-6" role="dialog" aria-modal="true" aria-labelledby="esito-modal-title"
    use:modal={{ onClose: () => (sending ? null : dispatch('close')) }}>
    <h2 id="esito-modal-title" class="text-lg text-heading font-display mb-1">{$t('esitoModal.title')}</h2>
    <p class="text-xs text-muted mb-3">{$t('esitoModal.sdiIdLabel')}: {identificativoSdi}</p>

    {#if !result?.success}
      <p class="text-sm mb-4" style="color: var(--color-text-body);">{$t('esitoModal.intro')}</p>
    {/if}

    {#if result}
      <div class="card p-4 mb-4 {result.success ? 'border-green-500' : 'border-red-500'}">
        <p class="font-bold {result.success ? 'text-success' : 'text-danger'}">
          {result.success ? $t('esitoModal.accepted') : `${$t('esitoModal.rejectedPrefix')}: ${result.sdiResponse?.esito || $t('esitoModal.unknown')}`}
        </p>
        {#if result.message}
          <p class="text-sm text-muted mt-1">{result.message}</p>
        {/if}
        {#if result.scartoDetails}
          <details class="mt-3">
            <summary class="eyebrow text-muted cursor-pointer">{$t('esitoModal.scartoDetails')}</summary>
            <pre class="mt-2 p-3 text-xs overflow-x-auto bg-surface-alt border border-gray-600">{result.scartoDetails}</pre>
          </details>
        {/if}
      </div>
    {/if}

    <ErrorBanner {error} />

    {#if !result?.success}
      <div class="space-y-4">
        <div>
          <label class="label" for="esito">{$t('esitoModal.choiceLabel')}</label>
          <select id="esito" class="input" bind:value={esito}>
            <option value="EC01">{$t('esitoModal.esitoAccept')}</option>
            <option value="EC02">{$t('esitoModal.esitoReject')}</option>
          </select>
          <p class="mt-1 text-xs text-muted">
            {esito === 'EC01' ? $t('esitoModal.acceptHelp') : $t('esitoModal.rejectHelp')}
          </p>
        </div>

        <div>
          <label class="label" for="numeroFattura">{$t('esitoModal.invoiceNumber')}</label>
          <input id="numeroFattura" type="text" class="input" bind:value={numeroFattura}
            placeholder={$t('esitoModal.invoiceNumberPlaceholder')} />
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="label" for="annoFattura">{$t('esitoModal.invoiceYear')}</label>
            <input id="annoFattura" type="number" class="input" bind:value={annoFattura} />
          </div>
          <div>
            <label class="label" for="posizioneFattura">{$t('esitoModal.position')}</label>
            <input id="posizioneFattura" type="number" class="input" bind:value={posizioneFattura} />
            <p class="mt-1 text-xs text-muted">{$t('esitoModal.positionHelp')}</p>
          </div>
        </div>

        <div>
          <label class="label" for="descrizione">{$t('esitoModal.description')}</label>
          <input id="descrizione" type="text" class="input" bind:value={descrizione} placeholder={$t('esitoModal.descriptionPlaceholder')} />
        </div>

        <div class="flex justify-end gap-3 pt-2">
          <button class="btn btn-secondary btn-sm" on:click={() => dispatch('close')} disabled={sending}>{$t('common.cancel')}</button>
          <button class="btn btn-primary btn-sm" on:click={handleSend} disabled={sending || !numeroFattura}>
            {sending ? $t('app.sending') : (esito === 'EC01' ? $t('esitoModal.sendAccept') : $t('esitoModal.sendReject'))}
          </button>
        </div>
      </div>
    {:else}
      <div class="flex justify-end pt-2">
        <button class="btn btn-primary btn-sm" on:click={() => dispatch('close')}>{$t('common.close')}</button>
      </div>
    {/if}
  </div>
</div>
